import React, { useState } from 'react';
import { OnboardingChecklist } from '@/components/OnboardingChecklist';
import { AchievementBadges } from '@/components/AchievementBadges';
import { OnboardingLoadingSkeleton } from '@/components/OnboardingLoadingSkeleton';
import { useServicesStore } from '@/stores/servicesStore';
import { useTeamsStore } from '@/stores/teamsStore';
import { useEnvironmentsStore } from '@/stores/environmentsStore';
import { useMonitoringConfigsStore } from '@/stores/monitoringConfigsStore';

export const GamificationPanel: React.FC = () => {
  // Read data from stores - stores auto-fetch on account changes
  const services = useServicesStore(state => state.services);
  const teams = useTeamsStore(state => state.teams);
  const environments = useEnvironmentsStore(state => state.environments);
  const monitoringConfigs = useMonitoringConfigsStore(state => state.configs);
  
  // Read loading states
  const servicesLoading = useServicesStore(state => state.loading);
  const teamsLoading = useTeamsStore(state => state.loading);
  const environmentsLoading = useEnvironmentsStore(state => state.loading);
  const monitoringLoading = useMonitoringConfigsStore(state => state.loading);
  
  const [isTransitioning, setIsTransitioning] = useState(false);

  const isLoading = servicesLoading || teamsLoading || environmentsLoading || monitoringLoading;
  const hasNoData = services.length === 0 && teams.length === 0 && environments.length === 0;
  const isInitialLoad = isLoading && hasNoData;

  // Check if onboarding is complete
  const hasMonitoringConfigs = monitoringConfigs.length > 0;
  const isOnboardingComplete = 
    environments.length > 0 &&
    teams.length > 0 &&
    services.length > 0 &&
    hasMonitoringConfigs;

  // Check if any achievements are unlocked
  const hasAchievements = isOnboardingComplete;

  // Show loading skeleton during initial load or transition
  if (isInitialLoad || isTransitioning) {
    return (
      <div className="transition-opacity duration-300">
        <OnboardingLoadingSkeleton />
      </div>
    );
  }

  // Show onboarding checklist if not complete
  if (!isOnboardingComplete) {
    return (
      <div className="transition-all duration-300 ease-in-out">
        <OnboardingChecklist hasMonitoringConfigs={hasMonitoringConfigs} />
      </div>
    );
  }

  // Show achievements if onboarding is complete
  if (hasAchievements) {
    return (
      <div className="transition-all duration-300 ease-in-out">
        <AchievementBadges />
      </div>
    );
  }

  // Don't show anything if no data and not loading
  return null;
};
